import React, {Component} from 'react';
import {getText} from '../../../../../helpers/localization';
import marketStyle from '../css/markets.css';
import OddsCard from './oddsCard';

class Handicap extends Component {
    _openMoreBets(matchdayEventId) {
        let storeData = this.props.store.getState();
        storeData.vpp.matchday.selectedMatchdayEvent = matchdayEventId;
    }

    render() {
        let store = this.props.store;
        let matchdayMarkets = this.props.matchdayMarkets;
        let handicapMarkets = matchdayMarkets.map((eventMarket, index) => {

            let content = [];
            for (let i = 0; i < eventMarket.market.length; i += 3) {

                //This is provided to show Team Name insted of WIN/LOSE
                if (eventMarket.market[i].selection.toLowerCase() === 'win')
                    eventMarket.market[i].selection = "Matchday_" + eventMarket.event.teamOne;

                if (eventMarket.market[i + 2].selection.toLowerCase() === 'lose')
                    eventMarket.market[i + 2].selection = "Matchday_" + eventMarket.event.teamTwo;

                content.push(<div className={marketStyle.marketGroup} key={i}>
                    <div className={marketStyle.scoreGroupHandicapPrefix}>
                        {i === 0 ?
                            <span className={marketStyle.marketLabel}>{getText('+1G', this.props.store)}</span> : ''}
                    </div>
                    <div className={marketStyle.scoreGroupHandicap}>
                        <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                            <span>1</span>
                        </div>
                        <div className={marketStyle.oddsContainerSmall}>
                            <OddsCard store={store} market={eventMarket.market[i]} event={eventMarket.event}/>
                        </div>
                    </div>
                    <div className={marketStyle.scoreGroupHandicap}>
                        <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                            <span>X</span>
                        </div>
                        <div className={marketStyle.oddsContainerSmall}>
                            <OddsCard store={store} market={eventMarket.market[i + 1]} event={eventMarket.event}/>
                        </div>
                    </div>
                    <div className={marketStyle.scoreGroupHandicap}>
                        <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                            <span>2</span>
                        </div>
                        <div className={marketStyle.oddsContainerSmall}>
                            <OddsCard store={store} market={eventMarket.market[i + 2]} event={eventMarket.event}/>
                        </div>
                    </div>
                    <div className={marketStyle.scoreGroupHandicapPrefix}>
                        {i !== 0 ?
                            <span className={marketStyle.marketLabel}>{getText('+1G', this.props.store)}</span> : ''}
                    </div>
                </div>);
            }
            return content;
        });
        return (
            <div>
                {handicapMarkets}
            </div>
        );
    }
}

export default Handicap;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/handicap.js